import React, { useRef } from 'react';

import { useReactToPrint } from 'react-to-print';

import { ImPrinter } from 'react-icons/im';
import { BsCheckCircle } from 'react-icons/bs';

import { PrinterButton } from './styles';

import { IOrder } from '../../interfaces/IOrder';
import { IDeliveryAddress } from '../../interfaces/IDeliveryAddress';
import { IPaymentMethod } from '../../interfaces/IPaymentMethod';
import { IOrderItem } from '../../interfaces/IOrderItem';
import ComponentToPrint from '../../newPages/OrderMonitor/ComponentToPrint';

interface PrinterProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  pedido: Partial<IOrder> & {
    deliveryAddress?: Partial<IDeliveryAddress> | undefined;
    orderPayment: Partial<IPaymentMethod> & {
      companyPaymentMethod?: any;
    };
    items: Partial<IOrderItem>[];
  };
  label?: string;
  backgroundColor: string;
  textColor: string;
}

const Printer: React.FC<PrinterProps> = ({
  pedido,
  label,
  backgroundColor,
  textColor,
  onClick,
  ...rest
}) => {
  const inputEl = useRef(null);

  const handlePrint = useReactToPrint({
    content: () => inputEl.current,
  });

  return (
    <>
      <div style={{ display: 'none' }}>
        <ComponentToPrint ref={inputEl} pedido={pedido} />
      </div>

      <PrinterButton
        backgroundColor={backgroundColor}
        textColor={textColor}
        onClick={(params) => {
          onClick && onClick(params);
          handlePrint && handlePrint();
        }}
        {...rest}
      >
        {label ? <BsCheckCircle size={20} /> : <ImPrinter size={20} />}
        {label}
      </PrinterButton>
    </>
  );
};

export default Printer;
